import { useState } from 'react';
import { VideoThumb } from '../JobList';
import Lightbox from './Lightbox';

interface MediaCardProps {
  type: 'image' | 'video' | 'audio';
  url: string;
  name: string;
  viewOnly?: boolean;
  onSelect?: () => void;
  onClear?: () => void;
  onPickerOpen?: () => void;
  canSelect?: boolean;
}

export default function MediaCard({
  type,
  url,
  name,
  viewOnly = false,
  onSelect,
  onClear,
  onPickerOpen,
  canSelect = true,
}: MediaCardProps) {
  const [previewOpen, setPreviewOpen] = useState(false);
  return (
    <div
      className={`flex rounded-xl ${
        viewOnly
          ? 'border border-border'
          : 'shadow-xl'
      }`}
    >
      <div
        className={`w-[200px] border border-border rounded-l-xl bg-white flex items-center justify-center overflow-hidden ${
          type === 'audio' ? 'h-20 px-2 py-4 !bg-transparent' : 'h-[150px]'
        }`}
      >
        {type === 'image' && (
          <img
            src={url}
            alt={name}
            className="w-full h-full object-cover cursor-pointer"
            onClick={onSelect}
          />
        )}
        {type === 'audio' && <audio controls preload="none" src={url} className="w-full" />}
        {type === 'video' && (
          <div className="w-full h-full [&_button]:max-w-none [&_button]:w-full [&_button]:h-full [&_img]:rounded-none [&_img]:aspect-auto [&_div]:rounded-none [&_div]:aspect-auto">
            <VideoThumb
              url={url}
              name={name}
              onClick={() => setPreviewOpen(true)}
              displayName={false}
            />
          </div>
        )}
      </div>
      <div className="px-4 py-2 grow flex flex-col justify-between">
        <div className="font-semibold min-w-0 overflow-hidden text-ellipsis whitespace-nowrap" title={name}>
          {name}
        </div>
        {!viewOnly && (
          <div className="flex justify-start gap-4">
            {onPickerOpen ? (
              <button type="button" className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover" onClick={onPickerOpen}>
                Change
              </button>
            ) : (
              <button
                type="button"
                className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover"
                onClick={onSelect}
                disabled={!canSelect}
              >
                Select
              </button>
            )}
            {type !== 'audio' && (
              <button
                type="button"
                className="rounded-md border border-border/60 bg-card px-4 py-2 text-sm font-medium text-accent-foreground transition-colors hover:bg-secondary"
                onClick={() => setPreviewOpen(true)}
              >
                Preview
              </button>
            )}
            {onClear && (
              <button type="button" className="rounded-md border border-border/60 bg-card px-4 py-2 text-sm font-medium text-accent-foreground transition-colors hover:bg-secondary ml-auto" onClick={onClear}>
                Clear
              </button>
            )}
          </div>
        )}
      </div>
      {previewOpen && type !== 'audio' && (
        <Lightbox
          type={type}
          url={url}
          name={name}
          onClose={() => setPreviewOpen(false)}
          onSelect={() => {
            onSelect?.();
            setPreviewOpen(false);
          }}
          displaySelect={canSelect}
        />
      )}
    </div>
  );
}
